import React, {Component} from "react";
import {injectIntl} from "react-intl";
import Own from './Own';
import Wait from './Wait';
import MobilitySolution from "./MobilitySolution";
import {connect} from "react-redux";
import Intervention from "../../../services/Intervention";
import InterventionService from "../../../services/Intervention";
import moment from 'moment';

import "./MobilityCard.css";
import Constants from "../../../services/Constants";
import Card from "../../common/Card";
import RoadAssist from "./RoadAssist";
import No from "./No";

class MobilityCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pristine: false
    }
  }

  componentDidMount() {
    const {intervention, intervention: {journey, journey: {properties} = {}} = {}} = this.props;
    if (journey && properties.services) {
      const oas = InterventionService.isOAS(intervention);
      const {services = []} = properties.services;
      const request = {services: services.map(e => oas ? e.id : e.name), waitingAtDealership: true};
      this.props.dispatchFetchAvailabilities(journey.interventionId, request);
    }
    if (properties && properties.mobility) {
      const {mobility, workspaceRequest} = properties.mobility;
      this.setState({mobility: mobility.name, workspaceRequest});
    }
  }

  canWaitAtDealership = (availabilities = []) => {
    const {intervention: {startDate, journey: {properties: {reception = {}} = {}} = {}}} = this.props;
    const availability = availabilities.find(a => a.day === moment(startDate).format(Constants.DATE_FORMAT_API));
    if (!availability) {
      return false;
    }
    const {availableSlots = []} = availability;

    if (reception.dropOff && !reception.dropOff.duringWorkingHours) {
      return false;
    }

    const interventionStart = moment(startDate).format(Constants.TIME_FORMAT_API);
    const slot = availableSlots.find(e => {
      const startTime = moment(e.startTime, Constants.TIME_FORMAT_API);   // specified format to avoid JS console warning
      const endTime = moment(e.endTime, Constants.TIME_FORMAT_API);       // specified format to avoid JS console warning
      return !(moment(interventionStart, Constants.TIME_FORMAT_API).isAfter(endTime) || moment(interventionStart, Constants.TIME_FORMAT_API).isBefore(startTime));
    });
    return slot !== undefined;
  };

  componentWillReceiveProps(nextProps) {
    const {waitingEnabled} = this.state;
    if (nextProps.fetchAvailabilities && nextProps.fetchAvailabilities.availabilities && !waitingEnabled) {
      const waitingEnabled = this.canWaitAtDealership(nextProps.fetchAvailabilities.availabilities);
      this.setState({waitingEnabled})
    }
  }

  onMobilitySave = () => {
    const {intervention: {journey: {id}}} = this.props;
    const {mobility} = this.state;
    this.props.dispatchUpdateMobility(id, {mobility});
    this.setState({pristine: false}); // as they do not know the meaning of pristine :-(
  };

  onMobilitySelect = (mobility) => {
    if (mobility === this.state.mobility) {
      return;
    }
    const {intervention, canWrite} = this.props;
    if (canWrite && !Intervention.isComplete(intervention)) {
      this.setState({mobility, pristine: true});
    }
  };

  render() {
    const {intl: {formatMessage}, connectedUserId, intervention, intervention: {journey, origin}, updateJourneyMobility: {error = {}}, canWrite} = this.props;
    const {mobility, workspaceRequest, waitingEnabled, pristine} = this.state;
    const errors = error.content || {};

    if (!mobility) {
      return null;
    }

    const {properties, properties: {reception: {dropOff = {}} = {}} = {}} = journey;
    const defaultMobility = properties.mobility.mobility;
    if (!waitingEnabled && mobility === 'wait' && defaultMobility.name !== 'wait') {
      errors.mobility = {message: 'error.mobility.waiting-exceeded'}
    }
    if (dropOff.duringWorkingHours === false && mobility === 'wait') {
      errors.mobility = {message: 'error.mobility.wait-247'}
    }

    return (
      <Card
        title={formatMessage({id: 'appointment.detail.mobility.title'})}
        pristine={pristine}
        onAlert={journey.requiresAttention.includes('mobility')}
        button={canWrite && !Intervention.isComplete(intervention) &&
          <button onClick={this.onMobilitySave} disabled={!pristine} type="primary" className={`btn btn-sm btn-primary`}>
            {formatMessage({id: 'action.save'})}
          </button>
        }
      >
        <h3 className="box__subtitle">{formatMessage({id: 'appointment.detail.mobility.drop-off.title'})}</h3>
        {errors && errors.mobility &&
          <div className="alert alert--error">
            {formatMessage({id: errors.mobility.message})}
          </div>
        }

        <div className="row">
          <MobilitySolution selected={!['own', 'wait', 'road_assist', 'no'].includes(mobility)} onSelect={this.onMobilitySelect} pristine={pristine}
                            canWrite={canWrite} intervention={intervention} mobility={mobility} connectedUserId={connectedUserId}/>
          <Own selected={mobility === 'own'} onSelect={() => this.onMobilitySelect('own')}/>
          <Wait selected={mobility === 'wait'} onSelect={() => this.onMobilitySelect('wait')}
                workspaceRequest={workspaceRequest || false}/>
          {origin === Constants.ORIGIN_CALL_CENTER.value &&
            <React.Fragment>
              <RoadAssist selected={mobility === 'road_assist'} onSelect={() => this.onMobilitySelect('road_assist')}/>
              <No selected={mobility === 'no'} onSelect={() => this.onMobilitySelect('no')}/>
            </React.Fragment>
          }
        </div>


      </Card>
    )
  }
}

const mapStateToProps = state => ({
  intervention: state.fetchIntervention && state.fetchIntervention.intervention,
  fetchAvailabilities: state.fetchAvailabilities,
  updateJourneyMobility: state.updateJourneyMobility
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchAvailabilities: (id, services) => dispatch({type: 'FETCH_AVAILABILITIES.REQUEST', id, services}),
  dispatchUpdateMobility: (id, body) => dispatch({type: 'UPDATE_JOURNEY_MOBILITY.REQUEST', id, body}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(MobilityCard))
